import { createSlice } from "@reduxjs/toolkit";
import {
  getServicesService,
  getServiceByIdService,
  createServiceService,
  updateServiceService,
  deleteServiceService,
} from "../services/services_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  servicesList: [],
  serviceInfo:{}
};

const slice = createSlice({
  name: "services",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getServicesService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.servicesList = action.payload?.data?.data;
        console.log(state.servicesList)
      })
      .addCase(getServicesService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getServicesService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })  .addCase(getServiceByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.serviceInfo = action.payload?.data?.data;
        console.log(state.serviceInfo)
      })
      .addCase(getServiceByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getServiceByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
